import Vue from 'vue'
import Router from 'vue-router'

//登录
import login from '@/views/login';
import bannerlist from '@/views/banners/list';
import homeindex from '@/views/home/index';
import booklist from '@/views/book/list';
import category from '@/views/book/category';
import units from '@/views/book/units';
import words from '@/views/book/words';
import daily from '@/views/book/daily';
import feedbacklist from '@/views/feedback/list';
import config from '@/views/system/config';
import userslist from '@/views/users/list';
import managerslist from '@/views/managers/list';
import managerspassword from '@/views/managers/password';
import messages from '@/views/system/messages';
import shipping from '@/views/shipping/list';
import userrank from '@/views/userrank/list';
import userrankdetail from '@/views/userrank/detail';

//首页
import index from '@/views/index';

Vue.use(Router)
//cv以下代码解决路由地址重复的报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    { path: '/login', name: '登录', component: login, hidden: true, meta: { requireAuth: false } },
    { path: '/', name: '', component: login, hidden: true, meta: { requireAuth: false } },
    {
      path: '/index', name: '首页', component: index, iconCls: 'el-icon-tickets',
      children: [
        { path: '/home/index', name: '工作台', component: homeindex, meta: { requireAuth: true } },
        { path: '/banners/list', name: 'Banner管理', component: bannerlist, meta: { requireAuth: true } },
        { path: '/book/list', name: '词书管理', component: booklist, meta: { requireAuth: true } },
        { path: '/book/category', name: '词书列表', component: category, meta: { requireAuth: true } },
        { path: '/book/words', name: '词书详情', component: words, meta: { requireAuth: true } },
        { path: '/book/units', name: '词书单元', component: units, meta: { requireAuth: true } },
        { path: '/book/daily', name: '词书学习计划', component: daily, meta: { requireAuth: true } },
        { path: '/feedback/list', name: '意见反馈', component: feedbacklist, meta: { requireAuth: true } },
        { path: '/system/config', name: '打卡积分', component: config, meta: { requireAuth: true } },
        { path: '/users/list', name: '用户列表', component: userslist, meta: { requireAuth: true } },
        { path: '/userrank/list', name: '排行榜设置', component: userrank, meta: { requireAuth: true } },
        { path: '/userrank/detail', name: '排行榜列表', component: userrankdetail, meta: { requireAuth: true } },
        { path: '/managers/list', name: '管理员列表', component: managerslist, meta: { requireAuth: true } },
        { path: '/managers/password', name: '修改密码', component: managerspassword, meta: { requireAuth: true } },
        { path: '/system/messages', name: '消息列表', component: messages, meta: { requireAuth: true } },
        { path: '/shipping/list', name: '兑换列表', component: shipping, meta: { requireAuth: true } },

      ]
    },

  ]


})



// WEBPACK FOOTER //
// ./src/router/index.js